module.exports = __webpack_public_path__ + "img/logo.8b7b00d2.png";